/**
 * Returns an object without any `prototype` properties.
 *
 * @internal
 */
export const getCleanObject = <T extends {}>(obj: T): T => Object.assign(Object.create(null), obj)
